var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14 6.753L1.658 11.549C1.012 12.115 3.67706e-07 11.655 3.67706e-07 10.796V1.204C-0.000164459 1.01175 0.0550878 0.823537 0.159141 0.661886C0.263194 0.500236 0.411637 0.372005 0.586693 0.292549C0.761749 0.213093 0.955998 0.185781 1.14618 0.213882C1.33636 0.241984 1.51441 0.324309 1.659 0.450998L7.139 5.247C7.24641 5.34086 7.3325 5.45661 7.39148 5.58649C7.45046 5.71636 7.48098 5.85736 7.48098 6C7.48098 6.14264 7.45046 6.28363 7.39148 6.41351C7.3325 6.54338 7.24641 6.65914 7.139 6.753H7.14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.ef047f48ec95ed7f34b8629f0672352d.svg";
export { ForwardRef as ReactComponent };